import React from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  ReferenceLine,
  ReferenceArea,
  ReferenceDot
} from "recharts";

function ChartSection({ metrics, milestones, treatmentSpacing, zoomRange, setSelectedTreatmentIndex, activeMetric }) {
  const latest = metrics.at(-1)?.value || "--";
  const average =
    Math.round(metrics.reduce((acc, cur) => acc + cur.value, 0) / metrics.length) || "--";

  return (
    <div className="chart-area" style={{ paddingTop: '4px' }}>
      {/* Title with larger font and tighter spacing */}
      <div style={{
        textAlign: 'center',
        fontSize: '18px',  // Increased from 16px
        fontWeight: '600',
        color: '#4a148c',
        padding: '4px 0 8px 0'  // Tighter padding (top right bottom left)
      }}>
        {activeMetric} Over Time
      </div>

      <ResponsiveContainer width="100%" height="100%">
        <LineChart
          data={metrics}
          margin={{ top: 10, right: 30, left: 20, bottom: 20 }}
        >
          {/* Rest of your EXACT chart code remains unchanged */}
          <text
            x="50%"
            y={290}
            textAnchor="middle"
            fontSize={12}
          >
            Time (days)
          </text>

          <text
            x={-150}
            y={20}
            transform="rotate(-90)"
            textAnchor="middle"
            dominantBaseline="hanging"
            fontSize={12}
          >
            Value
          </text>

          <CartesianGrid strokeDasharray="3 3" />
          <XAxis
            dataKey="time"
            type="number"
            domain={zoomRange || [0, 99]}
          />
          <YAxis />
          <Tooltip />

          {treatmentSpacing.map((item, i) => (
            <ReferenceArea
              key={`region-${i}`}
              x1={item.xStart}
              x2={item.xEnd}
              fill={i % 2 === 0 ? "#c7d2fe" : "#fbcfe8"}
              fillOpacity={0.2}
            />
          ))}

          <Line
            type="monotone"
            dataKey="value"
            stroke="#7c3aed"
            strokeWidth={2}
            dot={{
              r: 3,
              stroke: "#7c3aed",
              strokeWidth: 2,
              fill: "#fff",
            }}
          />

          {milestones.map((m, i) => {
            const actual = metrics.find((pt) => pt.time === new Date(m.date).getDate());
            const delta = actual ? actual.value - parseFloat(m.value) : null;
            const color = !delta
              ? "#999"
              : Math.abs(delta) < 5
                ? "#facc15"
                : "#ef4444";

            return (
              <ReferenceDot
                key={`milestone-dot-${i}`}
                x={new Date(m.date).getDate()}
                y={parseFloat(m.value)}
                r={5}
                fill={color}
                stroke="#000"
                strokeWidth={1}
                label={{
                  position: "top",
                  fontSize: 10,
                  fill: color,
                }}
              />
            );
          })}

          {treatmentSpacing.map((item, i) => {
            const mid = (item.xStart + item.xEnd) / 2;
            return (
              <ReferenceLine
                key={`treatment-${i}`}
                x={mid}
                stroke="transparent"
                label={{
                  value: `${item.dosage || "2mg"} ${item.name.split(" ")[0]}`,
                  position: "middle",
                  fontSize: 13,
                  fontWeight: 600,
                  fill: "#4f46e5",
                  dy: -10,
                  textAnchor: "middle",
                }}
              />
            );
          })}
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}

export default ChartSection;